import { Web3Provider } from '@ethersproject/providers';
import { BigNumber } from 'ethers';
import { hexStripZeros } from 'ethers/lib/utils';
import { ChainInfo, SupportedChains } from '../../config/constants';

type AddNetworkParams = {
    library: Web3Provider;
    chainId: SupportedChains;
    chainInfo: ChainInfo[SupportedChains];
};

const addNetwork = async ({ library, chainId, chainInfo }: AddNetworkParams) => {
    if (!library.provider.request) return;

    const formattedChainId = hexStripZeros(BigNumber.from(chainId).toHexString());

    await library.provider.request({
        method: 'wallet_addEthereumChain',
        params: [
            {
                chainId: formattedChainId,
                chainName: chainInfo.name,
                rpcUrls: chainInfo.rpcUrls,
                nativeCurrency: chainInfo.nativeCurrency,
                blockExplorerUrls: [chainInfo.blockExplorer],
            },
        ],
    });
};

export default addNetwork;
